module.exports = __webpack_public_path__ + "files/180f9bc88d17e8e3008d3ae0b1647352.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bolditalic-webfont.svg
 ** module id = 986
 ** module chunks = 0
 **/